module.exports = __webpack_public_path__ + "img/1510.215fd12d.gif";